__turbopack_context__.v({
  "boostedText": "JXxf5G_boostedText",
  "image": "JXxf5G_image",
  "imageOverlay": "JXxf5G_imageOverlay",
  "imageWrapper": "JXxf5G_imageWrapper",
  "interactiveImageWrapper": "JXxf5G_interactiveImageWrapper",
  "likesNumber": "JXxf5G_likesNumber",
  "likesWrapper": "JXxf5G_likesWrapper",
  "soldText": "JXxf5G_soldText",
});
